<div class="services maximized-component">
    <div class="grids-container">
        <div id="services-section">
            <res-generic-grid [gridName]="gridName" [automationId]="automationId"
                [headerTemplate]="headerTemplate" [(isBusy)]="isBusy" [pagerVisible]="false" [(isBusyMessage)]="isBusyMessage"
                [columnDefs]="columnDefs" [requestInfo]="requestInfo" [gridContext]="gridContext" [contextMenuOptions]="contextMenuOptions"
                [responseArrayCallback]="responseArrayCallback" [responseCallback]="responseCallback" [showHeaderContextMenu]="false"
                [rowSelection]="servicesSelection" [pagerVisible]="false" [onSelectionChanged]="onSelectionChanged" [loadDataFinishedCallback]="loadDataFinishedCallback">
            </res-generic-grid>
            <ng-template #headerTemplate>
                <div class="parent-header" [ngClass]="[!hasServiceAddEditPermissions ? 'top-margin' : '']">
                    <span>Services</span>
                    <div class="new-service">
                        <button type="button" data-automation-id="services-settings-add-new-service-button"
                        class="secondary-button" (click)="addEditNewService()" *ngIf="hasServiceAddEditPermissions">
                        <i class="fa fa-plus"></i>New Service ...
                    </button>
                </div>
                </div>
            </ng-template>
        </div>
        <res-resizer [attr.data-automation-id]="'services-resizer'" anchor="left"
            resizingElementId="services-section" secondElementId="realm-nodes-section" [usePercentages]="true"
            [initSize]="50" [minSize]="30" [maxSize]="80" [ellipsisExpander]="true"></res-resizer>
        <div id="realm-nodes-section">
            <div class="content">
                <div id="topSection">
                    <res-generic-grid #realmnodes [automationId]="realmNodesAutoId" [rowSelection]="realmNodesSelection"
                    [pagerVisible]="false" [columnDefs]="realmNodesGridColDefs" [gridName]="gridNameRealmNodes"
                    [headerTemplate]="realmNodesHeaderTemplate" [onSelectionChanged]="realNodesOnSelectionChanged"
                    [gridContext]="gridContextRealmNodes" [rowClassRules]="rowClassRules">
                </res-generic-grid>
                <ng-template #realmNodesHeaderTemplate>
                    <div class="parent-header">
                        <span>Realm Nodes</span>
                        <div class="realm-nodes-actions">
                            <button type="button" data-automation-id="realm-nodes-save-button"
                            class="primary-button" (click)="saveRealmNodes()"
                            *ngIf="hasServiceAddEditPermissions" [disabled]="isDisabled() || (noRealmNodesSelected && isDirty)">Save</button>
                        <button type="button" data-automation-id="realm-nodes-discard-changes-button"
                            class="secondary-button" (click)="discardRealmNodesChanges()" [disabled]="isDisabled()"
                            *ngIf="hasServiceAddEditPermissions">Discard Changes</button>
                        </div>
                    </div>
                    <div class="help">
                        <button type="button" class="help-button"
                        [attr.data-automation-id]="automationId + '-help-button'" (click)="openHelp()">
                        <i class="fa fa-question"></i>
                    </button>
                    </div>
                </ng-template>
                </div>

                <res-resizer anchor="up" ellipsisExpander="true" resizingElementId="topSection" secondElementId="bottomSection"
                    [collapsible]="false" [initSize]="50" [minSize]="30" [maxSize]="80" [usePercentages]="true"></res-resizer>

                <div id="bottomSection">
                    <res-generic-grid #organdprojects [automationId]="orgsAndProjectsAutoId"
                    [pagerVisible]="false" [columnDefs]="colDefsOrgsAndProjects"
                    [headerTemplate]="orgsAndProjectsHeaderTemplate"
                    [gridContext]="gridContextOrgsAndProjects">
                </res-generic-grid>
                <ng-template #orgsAndProjectsHeaderTemplate>
                    <div class="parent-header top">
                        <span>Organizations & Projects</span>
                    </div>
                </ng-template>
                </div>
            </div>
    </div>
</div>